<template>
	<div>
		<div class="content-box">

			<div class="element-wrapper compact pt-4" style="display: none">
				<div class="element-actions">
					<a class="btn btn-primary btn-sm" href="#"><i class="os-icon os-icon-ui-22"></i><span>Add Account</span></a><a class="btn btn-success btn-sm" href="#"><i class="os-icon os-icon-grid-10"></i><span>Make Payment</span></a>
				</div>
				<h6 class="element-header">
					Financial Overview
				</h6>
				<div class="element-box-tp">
					<div class="row">
						<div class="col-12">
							<!--START - BALANCES-->
							<div class="element-balances">
								<div class="balance hidden-mobile">
									<div class="balance-title">
										Total Balance
									</div>
									<div class="balance-value">
										<span>$350</span><span class="trending trending-down-basic"><span>%12</span><i class="os-icon os-icon-arrow-2-down"></i></span>
									</div>
									<div class="balance-link">
										<a class="btn btn-link btn-underlined" href="#"><span>View Statement</span><i class="os-icon os-icon-arrow-right4"></i></a>
									</div>
								</div>
								<div class="balance">
									<div class="balance-title">
										Credit Available
									</div>
									<div class="balance-value">
										$17,800
									</div>
									<div class="balance-link">
										<a class="btn btn-link btn-underlined" href="#"><span>Request Increase</span><i class="os-icon os-icon-arrow-right4"></i></a>
									</div>
								</div>
								<div class="balance">
									<div class="balance-title">
										Due Today
									</div>
									<div class="balance-value danger">
										$180
									</div>
									<div class="balance-link">
										<a class="btn btn-link btn-underlined btn-gold" href="#"><span>Pay Now</span><i class="os-icon os-icon-arrow-right4"></i></a>
									</div>
								</div>
							</div>
							<!--END - BALANCES-->
						</div>
					</div>
				</div>
			</div>
			<div class="row">

				<div class="col-12">
					<!--START - Money Withdraw Form-->
					<div class="element-wrapper">
						<activityWidget />
					</div>
					<!--END - Money Withdraw Form-->
				</div>
			</div>
			<!--START - Transactions Table-->
			<div class="element-wrapper" style="display: none">
				<h6 class="element-header">
					Recent Transactions
				</h6>
				<div class="element-box-tp">
					<div class="table-responsive">
						<table class="table table-padded">
							<thead>
							<tr>
								<th>
									Status
								</th>
								<th>
									Date
								</th>
								<th>
									Description
								</th>
								<th class="text-center">
									Category
								</th>
								<th class="text-right">
									Amount
								</th>
							</tr>
							</thead>
							<tbody>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller green"></span><span>Complete</span>
								</td>
								<td>
									<span>Today</span><span class="smaller lighter">1:52am</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company1.png" style="height: 25px;"><span>Banana Shakes LLC</span>
								</td>
								<td class="text-center">
									<a class="badge badge-success" href="">Shopping</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-success">+ 1,250 USD</span>
								</td>
							</tr>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller red"></span><span>Declined</span>
								</td>
								<td>
									<span>Jan 19th</span><span class="smaller lighter">3:22pm</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company2.png" style="height: 25px;"><span>Stripe Payment Processing</span>
								</td>
								<td class="text-center">
									<a class="badge badge-danger" href="">Cafe</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-success">+ 952.23 USD</span>
								</td>
							</tr>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller yellow"></span><span>Pending</span>
								</td>
								<td>
									<span>Yesterday</span><span class="smaller lighter">7:45am</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company3.png" style="height: 25px;"><span>MailChimp Services</span>
								</td>
								<td class="text-center">
									<a class="badge badge-warning" href="">Restaurants</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-danger">- 320 USD</span>
								</td>
							</tr>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller yellow"></span><span>Pending</span>
								</td>
								<td>
									<span>Jan 23rd</span><span class="smaller lighter">2:12pm</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company1.png" style="height: 25px;"><span>Starbucks Cafe</span>
								</td>
								<td class="text-center">
									<a class="badge badge-primary" href="">Shopping</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-success">+ 17.99 USD</span>
								</td>
							</tr>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller green"></span><span>Complete</span>
								</td>
								<td>
									<span>Jan 12th</span><span class="smaller lighter">9:51am</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company4.png" style="height: 25px;"><span>Ebay Marketplace</span>
								</td>
								<td class="text-center">
									<a class="badge badge-danger" href="">Groceries</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-danger">- 244 USD</span>
								</td>
							</tr>
							<tr>
								<td class="nowrap">
									<span class="status-pill smaller yellow"></span><span>Pending</span>
								</td>
								<td>
									<span>Jan 9th</span><span class="smaller lighter">12:45pm</span>
								</td>
								<td class="cell-with-media">
									<img alt="" src="img/company2.png" style="height: 25px;"><span>Envato Templates Inc</span>
								</td>
								<td class="text-center">
									<a class="badge badge-primary" href="">Business</a>
								</td>
								<td class="text-right bolder nowrap">
									<span class="text-success">+ 340 USD</span>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import userActions from '@/components/user/account/actions';
    import activityWidget from '@/components/user/widget/activityWidget'

    export default {
        name: 'userDashboard',
	    components: { userActions, activityWidget },
        data () {
            return {
                session: session
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/dashboard.vue